<div class="page">
    <div class="page-single">
        <div class="container">
            <div class="row">
                <div class="col col-login mx-auto">
                    <div class="text-center mb-6">
                        <img src="./assets/images/logo.png" class="h-6" alt="">
                    </div>
                    <form class="card" [formGroup]="resetPasswordForm" (submit)="resetPassword()">
                        <div class="card-body p-6">
                            <div class="note_of_reset mb-5"><span class="red">Note:</span> Please do not use any special characters</div>
                            <div class="card-title">Reset Password</div>
                            <div *ngIf="submitted && password_mismatched" class="invalid-feedback">
                                <div *ngIf="password_mismatched">New password and confirm password mismatched</div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">New Password</label>
                                <input type="password" class="form-control" formControlName="new_password" placeholder="Enter Password">
                                <div *ngIf="submitted && f.new_password.errors" class="invalid-feedback">
                                    <div *ngIf="f.new_password.errors.required">New Password is required</div>
                                </div>
                                <div *ngIf="submitted && f.new_password.errors" class="invalid-feedback">
                                    <div *ngIf="!f.new_password.valid && f.new_password.value">New password must be minimum 8 characters.</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Confirm Password</label>
                                <input type="password" class="form-control" formControlName="confirm_password" placeholder="Confirm Password">
                                <div *ngIf="submitted && f.confirm_password.errors" class="invalid-feedback">
                                    <div *ngIf="f.confirm_password.errors.required">Confirm Password is required</div>
                                </div>
                                <div *ngIf="submitted && f.confirm_password.errors" class="invalid-feedback">
                                    <div *ngIf="!f.confirm_password.valid && f.confirm_password.value">Confirm password must be minimum 8 characters.</div>
                                </div>
                            </div>
                            <div class="form-footer">
                                <button type="submit" class="btn btn-primary" [disabled]="loading"><i class="fas fa-spin fa-spinner" *ngIf="loading"></i> Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
